import Swiper, { EffectFade, Autoplay } from "swiper";

// configure Swiper to use modules
Swiper.use([EffectFade, Autoplay]);

(function () {
  let subheadlineSwiper = new Swiper(".fade-headlines", {
    speed: 1500,
    loop: true,
    // slidesPerView: 1,
    // spaceBetween: 15,
    // autoHeight: true,
    fadeEffect: {
      crossFade: true,
    },
    effect: "fade",
    virtualTranslate: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
  });
})();
